/**
 * מטבע תצוגה לעמוד פרופיל חבילה דינמית: SSOT ותצוגה ב־ILS בלבד (ללא המרה ל־USD).
 */

import { formatIlsDisplay } from "../formatIlsDisplay";
import { resolveHotelProfileUiDisplayCurrency } from "../hotelSellingPrice";

/** מטבע חיפוש/הגדרות (audit בלבד) — לא לשימוש לתצוגת מחיר בפרופיל חבילה דינמית */
export function resolveDynamicPackageProfilePageDisplayCurrency(profilePriceContext) {
  return resolveHotelProfileUiDisplayCurrency(profilePriceContext);
}

/**
 * מחיר חבילה מ־SSOT: `package.finalDisplayPrice` כבר ב־ILS — רק עיצוב ₪.
 *
 * @param {number|null|undefined} ssotFinalIls
 * @param {object|null|undefined} profilePriceContext
 * @returns {string|null}
 */
export function formatDynamicPackageProfileSsotPackageFinalForDisplay(
  ssotFinalIls,
  profilePriceContext
) {
  const n = Number(ssotFinalIls);
  if (!Number.isFinite(n) || n <= 0) return null;
  return formatIlsDisplay(n);
}

/** רמז לבדיקות dev: סימbol מטבע בשורת תצוגה מעוצבת (₪ / $) */
export function inferFormattedHotelPriceCurrencyHint(formattedLine) {
  if (typeof formattedLine !== "string" || !formattedLine.trim()) return null;
  if (formattedLine.includes("₪")) return "ILS";
  if (formattedLine.includes("$")) return "USD";
  return null;
}

/**
 * לוג זמני לאיחוד מטבע בפרופיל חבילה דינמית (dev בלבד).
 * @param {object} payload
 */
export function logDynamicProfileCurrencyAudit(payload) {
  if (import.meta.env.PRODUCTION) return;
  try {
    console.info("[DYNAMIC_PROFILE_CURRENCY_AUDIT]", payload);
  } catch {
    /* ignore */
  }
}

/**
 * סכום ב־ILS מתוך מנוע SSOT (pre-HR / HR / final) → מחרוזת תצוגה ב־₪ בלבד.
 */
export function formatDynamicPackageProfileIlsAmountForDisplay(ilsAmount, profilePriceContext) {
  return formatDynamicPackageProfileSsotPackageFinalForDisplay(ilsAmount, profilePriceContext);
}

export function logDynamicPackageProfileCurrencyMismatchGuard({
  pageDisplayCurrency,
  headlineFormatted,
  roomCombinedSampleFormatted,
}) {
  if (import.meta.env.MODE === "production") return;
  const h = inferFormattedHotelPriceCurrencyHint(headlineFormatted);
  const r = inferFormattedHotelPriceCurrencyHint(roomCombinedSampleFormatted);
  if (h && r && h !== r) {
    // eslint-disable-next-line no-console -- audit
    console.error("[DYNAMIC_PACKAGE_PROFILE_CURRENCY] ERROR: headline vs room row currency hint mismatch", {
      pageDisplayCurrency,
      headlineHint: h,
      roomHint: r,
      headlineFormatted,
      roomCombinedSampleFormatted,
    });
  }
}
